export default {
    profile: 'ประวัติ',
    companyProfile: 'ประวัติบริษัท',
    companyName: 'ชื่อบริษัท',
    hqAddress: 'ที่อยู่สำนักงานใหญ่',
    businessDescription: 'คำอธิบายบริษัท',
    contact: 'ผู้ติดต่อ',
    fullName: 'ชื่อ นามสกุล',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    email: 'อีเมล',
    phoneNumber: 'เบอร์โทร',
    edit: 'แก้ไข',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    emailIsRequired: 'กรุณากรอกอีเมล',
    emailMustBeValid: 'รูปแบบอีเมลไม่ถูกต้อง',
    incorrectPhoneNubmer: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    companyProfileIsUpdated: 'ข้อมูลถูกอัปเดตแล้ว',
    imageCannotBeNull: 'กรุณาแนบรูปภาพ'
}
